import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateUserProfileAction } from "../../store/reducers/userSlice";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import ImageUploader from "../../components/common/imageUploader/ImageUploader";
import AccountInfoForm from "../components/account/AccountInfoFields";
import UserIcon from "../../assets/images/black_user.png";
import { useNavigate } from "react-router-dom";
import { setAdminErrorAction } from "../../store/reducers/adminClientsSlice";
import Notification from "../../components/common/notification/Notification";
import { setNotificationAction } from "../../store/reducers/mmymSlice";
import Validation from "../../utils/Validation";
import ManagePassword from "../components/account/ManagePassword";
interface UseDetails {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  photo?: string;
  socialNumber: string;
  status: string;
  userEmailSignature?: string;
}

const SuperAdminAccount = () => {
  const dispatch = useDispatch();
  const navigator = useNavigate();
const {isUserUpdateError, isUserUpdateSuccess} = useSelector((state:any)=> state.user);
  const { userProfile } = useSelector((state: any) => state.user);

  const [useDetails, setUserDetails] = useState<UseDetails>({
    firstName: "",
    lastName: "",
    email: "",
    phone: "", // Add the 'phone' property
    // photo: "",
    socialNumber: "",
    status: "",
    userEmailSignature:"",
  });

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    firstName: useDetails?.firstName,
    phone: useDetails?.phone,
  });

  const [isActionCalled, setIsActionCalled] = useState(false);
  const [countryCode, setCountryCode] = useState<string>("+44"); // State for country code
  const [isDisabled, setIsDisabled] = useState(true);
  const [uploadedImage, setUploadedImage] = useState<string | null>(null);

  useEffect(()=>{
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "error" }));
    }
  }, [])

  useEffect(() => {
    if (userProfile) {
      const extractedCountryCode = userProfile.phoneNumber?.match(/^\+91|\+44/);
      setCountryCode(extractedCountryCode ? extractedCountryCode[0] : "+44");
      setUserDetails({
        firstName: userProfile.name || "",
        lastName: userProfile.last_name || "",
        email: userProfile.email || "",
        phone: userProfile.phoneNumber ? userProfile.phoneNumber.replace(/^(\+91|\+44)/, "") : "",
        // photo: userProfile.photo || "",
        socialNumber: userProfile.social_number || "",
        status: userProfile.status || "",
        userEmailSignature: userProfile.user_email_signature || "",
      });
    }
  }, [dispatch, userProfile]);



  const handleImageUpload = (image: string | null) => {
    setUploadedImage(image);
    setIsDisabled(false);
  };

  const cancelBtnClick = () => {
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    dispatch(setAdminErrorAction(false));
    setUploadedImage(null);
    navigator("/dashboard");
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        const { email, ...payload } = useDetails;

        // Prepend country code to the phone number if it exists
        if (useDetails?.phone) {
          payload.phone = useDetails.phone ? `${countryCode}${useDetails.phone}`:'';
        }

        // Include uploaded image if available
        if (uploadedImage) {
          payload.photo = uploadedImage;
        }

        dispatch(updateUserProfileAction(payload));
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled, uploadedImage]);

  const [isPasswordModel, setIsPasswordModel] =useState(false);
  const handleChangePassword=()=>{
    setIsPasswordModel(true);
    dispatch(setNotificationAction({ message: [], severity: "error" }));

  }

  const handleClose=()=>{
    setIsPasswordModel(false);
  };

  useEffect(()=>{
    if(isUserUpdateSuccess){
      setIsDisabled(true);
      setUploadedImage(null);
    }
  },[isUserUpdateSuccess])

  return (
    <>
     {isPasswordModel && (
    <ManagePassword
     selectClient={""}
     open={isPasswordModel}
     onHide={handleClose}
     title="Change Password"
    />
     )}
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      sx={{ background: "#f4f4f4", height: "100vh", paddingTop: "10px" }}
    >
      <Grid item xs={12} md={12}>
        <Container fixed sx={{ bgcolor: "#fff", padding: "16px 0px" }}>
          <Box
            sx={{
              bgcolor: "#E5F4F1",
              height: "fit-content",
              border: "1px solid #d1cfcf",
              borderRadius: "5px",
              paddingBottom: "30px",
            }}
          >
            <Typography
              variant="h3"
              align="center"
              sx={{ fontWeight: "600", margin: "30px 0px" }}
            >
              Account Settings
            </Typography>

            <Grid container rowSpacing={1}>
              <Grid item xs={12} md={4} sx={{marginTop:'-15px'}} >
                <ImageUploader
                  showUploadButton={true}
                  defaultImage={userProfile?.logo || UserIcon}
                  onImageUpload={handleImageUpload}
                  width={136}
                  height={136}
                  btnName="Change"
                   page="profile"
               />
               
              </Grid>
              <Grid item xs={12} md={6}>
                {isUserUpdateError &&
                  <Notification />
                }
                
                <AccountInfoForm
                  error={error}
                  userProfile={userProfile}
                  setIsDisabled={setIsDisabled}
                  selectClient={""}
                  useDetails={useDetails}
                  setUserDetails={setUserDetails}
                  resetValidator={resetValidator}
                  checkValidator={checkValidator}
                  setCountryCode={setCountryCode}
                  countryCode={countryCode}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "capitalize",
                      width: "auto",
                      padding: "6px 16px",
                      marginTop: "30px",
                      marginLeft:'0px'
                    }}
                    onClick={(e: any) => handleChangePassword()}
                  >
                    Change Password
                  </Button>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button disabled={isDisabled}
                      variant="contained"
                      color="secondary"
                      sx={{
                        textTransform: "capitalize",
                        width: "100px",
                        padding: "6px 16px",
                        marginTop: "30px",
                        marginRight: "20px",
                      }}
                      onClick={(e: any) => handleSubmit(e)}
                    >
                      Save
                    </Button>
                    <Button
                      onClick={() => cancelBtnClick()}
                      variant="contained"
                      color="secondary"
                      sx={{
                        textTransform: "capitalize",
                        width: "100px",
                        padding: "6px 16px",
                        marginTop: "30px",
                      }}
                    >
                      Return
                    </Button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
    </Grid>
    </>
  );
};

export default SuperAdminAccount;
